import { CreateUserProvider } from '../../contexts/CreateUserContext';
import React from 'react';
import NewUserPage from './NewUserPage';

export default function NewUserPageWithContext() {
	return (
		<CreateUserProvider>
			<NewUserPage />
		</CreateUserProvider>
	);
}
